/*
 * @Descripttion:
 * @Date: 2021-05-31 15:21:30
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-07-08 21:12:16
 * @Author: Sima thief
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import axios from './axios/index'
import VueAxios from 'vue-axios'
import App from './App.vue'
import ElementUI from 'element-ui'
import '../element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
import store from './store/index.js'
import animated from 'animate.css'
import lodash from 'lodash'
// import gobal from './assets/css/gobal.scss'
Vue.use(animated);
// import './theme/index.css'
Vue.use(ElementUI);
import Setnum from '../common/setNumber.js'
import qs from 'qs'
Vue.config.productionTip = false;
// Vue.prototype.axios = axios;
Vue.prototype.$http = axios;
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

Vue.prototype.$Setnum = Setnum;
Vue.prototype._ = lodash;

import { ossPath } from '../devParams'
Vue.prototype.ossPath = ossPath
// router.beforeEach((to,from,next)=>{
//   console.log(to)
//   if(to.path!=='/index/placeOrder/placeIndex'){

//   }

//   next()
// })



// import moment from 'moment/moment'
// Vue.prototype.$moment = moment
// Vue.filter('moment', function (value, formatString) {
//   formatString = formatString || 'YYYY-MM-DD';
//   return moment(value).format(formatString); // value可以是普通日期 20170723
//   // return moment.unix(value).format(formatString); // 这是时间戳转时间
// });

/**
 * 时间转为 YYYY-MM-DD 格式
 */
import dayjs from "dayjs";
Vue.filter("toDate",function (value,style="YYYY-MM-DD"){
  if(!value) return "-";
  return dayjs(value).format(style);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js